import { DatabaseId } from "@syla/shared/types/helpers/Id";
import { parseDecimal } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { ModelTaxResultsResponse } from "@syla/shared/types/responses/ModelTaxResultsResponse";
import axios from "axios";

type ModelTaxYearProps = {
  accountId: DatabaseId;
  financialYearValue: string;
};

export async function modelTaxYearResult(
  props: ModelTaxYearProps,
): Promise<ModelTaxResultsResponse> {
  const response = await axios.post<TransportType<ModelTaxResultsResponse>>(
    `/accounts/${props.accountId}/model-tax-year-result`,
    {
      financialYearValue: props.financialYearValue,
    },
  );
  return deserialise(response.data);
}

function deserialise(
  data: TransportType<ModelTaxResultsResponse>,
): ModelTaxResultsResponse {
  if (!data) {
    return undefined;
  }

  return {
    taxResultSavings: data.taxResultSavings.map((taxYearDiff) => ({
      ...taxYearDiff,
      gain: parseDecimal(taxYearDiff.gain),
    })),
  };
}
